import script from "./PresupuestoPaciente.vue?vue&type=script&setup=true&lang=js"
export * from "./PresupuestoPaciente.vue?vue&type=script&setup=true&lang=js"

import "./PresupuestoPaciente.vue?vue&type=style&index=0&id=276673fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276673fc"]])

export default __exports__